import { render, staticRenderFns } from "./33-target.vue?vue&type=template&id=08802312&"
import script from "./33-target.vue?vue&type=script&lang=js&"
export * from "./33-target.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports